<template>
  <div class="layout">
    <router-view v-if="route.path === '/login'" class="full-page" />
    <template v-if="route.path != '/login'">
      <div class="layout-header">
        <div class="layout-header--logo" @click="router.push('/')">
          后台管理
        </div>
        <div class="layout-header--main">
          <el-icon @click="isCollapse = !isCollapse">
            <Menu />
          </el-icon>
        </div>
        <div style="padding-right: 20px; gap: 20px; display: flex; cursor: pointer">

          <button @click="playAudio" ref="playAudioBtn" style="
              display: block;
              width: 0;
              height: 0;
              overflow: hidden;
              opacity: 0;
            ">
            播放声音
          </button>
          <button @click="playAudiowithdraw" ref="playAudioBtnwithdraw" style="
              display: block;
              width: 0;
              height: 0;
              overflow: hidden;
              opacity: 0;
            ">
            播放声音
          </button>
          <audio controls ref="audioRef" preload="auto" loop
            style="display: block; width: 0; height: 0; overflow: hidden">
            <source src="./recharge.mp3" type="audio/mpeg" />
            Your browser does not support this audio format.
          </audio>
          <audio controls preload="auto" loop ref="audioRefwithdraw"
            style="display: block; width: 0; height: 0; overflow: hidden">
            <source src="./cash.mp3" type="audio/mpeg" />
            Your browser does not support this audio format.
          </audio>
          <div @click="toggleMute" :title="isMuted ? '打开声音' : '关闭声音'" style="width: 24px; height: 24px">
            <svg v-if="!isMuted" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
              <path d="M3 9v6h4l5 5V4L7 9H3zm13.5 3a4.5 4.5 0 0 1-4.5 4.5v-9a4.5 4.5 0 0 1 4.5 4.5z" />
            </svg>
            <svg v-else xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="white">
              <path
                d="M16.5 12a4.5 4.5 0 0 0-4.5-4.5v9a4.5 4.5 0 0 0 4.5-4.5zm1.91 5.59L4.41 4.09 3 5.5l4.47 4.47H3v6h4l5 5V13.9l5.5 5.5 1.41-1.41z" />
            </svg>
          </div>
          <el-badge title="在线人数" :value="onlineCount" @click="router.push('/userList')" class="item">
            <el-icon>
              <User />
            </el-icon>
          </el-badge>
        </div>

        <el-dropdown placement="bottom-start">
          <el-button>
            用户：
            {{ store.state.currentUser.username || currentUser.username }}
          </el-button>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item @click="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div class="layout-body">
        <leftMenu :isCollapse="isCollapse" />
        <!-- {{  store.state  }} -->
        <div class="layout-main">
          <div></div>
          <el-breadcrumb class="layout-main--breadcrumb" separator-icon="ArrowRight">
            <el-breadcrumb-item v-for="(item, index) in store.state.breakCum" :to="{ path: item.path }">{{ item.name
            }}</el-breadcrumb-item>
          </el-breadcrumb>
          <router-view class="layout-main--routerview" />
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance, onActivated } from "vue";
import leftMenu from "./leftMenu.vue";
import store from "@/store";
import { useRoute, useRouter } from "vue-router";
const isCollapse = ref(false);

let currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
onActivated(() => {
  currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
});
const route = useRoute();
const router = useRouter();
const notice = ref({
  recharge: 0, //充值
  withdraw: 0, //提款
});

const { proxy } = getCurrentInstance();
onMounted(() => {
  getOnlineCount();
});

const triggerProgrammaticClick = () => {
  const clickEvent = new MouseEvent("click", {
    bubbles: true, // 允许事件冒泡
    cancelable: true, // 允许事件被取消
    view: window, // 关联的 window 对象
  });

  playAudioBtn.value.dispatchEvent(clickEvent);
};
const triggerProgrammaticClickwithdraw = () => {
  const clickEvent = new MouseEvent("click", {
    bubbles: true, // 允许事件冒泡
    cancelable: true, // 允许事件被取消
    view: window, // 关联的 window 对象
  });

  playAudioBtnwithdraw.value.dispatchEvent(clickEvent);
};

const playAudioBtn = ref(null);
const playAudioBtnwithdraw = ref(null);
const audioRef = ref(null);
const audioRefwithdraw = ref(null);
const isMuted = ref(false);

const toggleMute = () => {
  isMuted.value = !isMuted.value;
  // 如果静音，则暂停播放
  if (isMuted.value) {
    audioRef.value.pause();
    audioRefwithdraw.value.pause();
  }
};

const playAudio = () => {
  audioRef.value.loop = true;
  audioRef.value.play().catch((e) => console.error("播放失败:", e));
};
const playAudiowithdraw = () => {
  audioRefwithdraw.value.loop = true;
  audioRefwithdraw.value.play().catch((e) => console.error("播放失败:", e));
};

const onlineCount = ref(0);
const getOnlineCount = async () => {
  try {
    const res = await proxy.$http({
      url: "/index/onlineUser",
    });
    if (res.code == 0) {
      onlineCount.value = res.data.count;
    }
  } catch (error) {
    console.log(error);
  }
};



const logout = () => {
  sessionStorage.removeItem("__TOKEN");
  currentUser = null;
  router.push("/login");
};
</script>

<style lang="less" scoped>
.layout {
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  &-header {
    background-color: #222222;
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    padding: 0 12px;

    &--logo {
      width: 220px;
      text-align: left;
      cursor: pointer;
    }

    &--main {
      flex: 1;
      width: 100%;
      color: #fff;
      text-align: left;

      .el-icon {
        cursor: pointer;
      }
    }
  }

  &-body {
    flex: 1;
    height: 100%;
    overflow: hidden;
    display: flex;
  }

  &-menu {
    // width: 220px;
    height: 100%;
    background-color: #eee;
    transition: all 0.25s;
  }

  .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 220px;
    min-height: 100%;
    background-color: #eee;
  }

  &-main {
    width: 100%;
    flex: 1;
    height: 100%;
    overflow: auto;
    transition: all 0.25s;
    background-color: rgb(241, 241, 241);
    display: flex;
    flex-direction: column;

    &--breadcrumb {
      height: 44px;
      display: flex;
      width: 100%;
      background-color: #fff;
      padding: 0 12px;
    }

    &--routerview {
      display: flex;
      flex: 1;
      height: 100%;
      margin: 12px;
      padding: 12px;
      overflow: auto;
      background-color: #fff;
      border-radius: 3px;
    }
  }
}
</style>
